import { render } from "./ECP.vue?vue&type=template&id=271dd53c"
import script from "./ECP.vue?vue&type=script&lang=js"
export * from "./ECP.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__